import { version } from '@/version'

let busyCount = 0

const TIMEOUT = 30 // seconds

export class TimeoutError extends Error {
	constructor(message) {
		super(message)
		this.name = 'TimeoutError'
	}
}

export class ConnectionError extends Error {
	constructor(message) {
		super(message)
		this.name = 'ConnectionError'
	}
}

export const callApi = function(method, endpoint, sendData, headers) {
	busyCount++

	const request = {
		method: method,
		headers: {
			'Content-Type': 'application/json',
			'X-Mobilbillet-Platform': 'Webshop',
			'X-Mobilbillet-Version': version,
			Accept: 'application/json',
			...headers
		},
		// mode: 'cors',
		cache: 'no-cache'
	}

	if (sendData !== null) {
		request.body = JSON.stringify(sendData)
	}

	const requestPromise = Promise.race([
		fetch(process.env.VUE_APP_API_URL + endpoint, request),
		new Promise((_resolve, reject) =>
			setTimeout(
				() =>
					reject(new TimeoutError('Connection timeout: ' + method + ' ' + endpoint + ' timed out after ' + TIMEOUT + ' seconds')),
				TIMEOUT * 1000
			)
		)
	])

	const responsePromise = requestPromise.then(response => {
		if (response.status === 200) {
			return response.json()
		}
		if (response.status === 204) {
			return response
		}
		return response.json()
	})

	return Promise.all([requestPromise, responsePromise])
		.then(values => {
			// Restore busy state before calling callback so that we can restore focus to an element that was
			// disabled during the AJAX call.
			busyCount--
			const response = values[0]
			const responseJson = values[1]

			return {
				ok: response.ok,
				status: response.status,
				statusText: response.statusText,
				responseBody: responseJson
			}
		})
		.catch(response => {
			busyCount--

			let error = new ConnectionError(method + ' ' + endpoint + ' - ' + response.message)

			if (response instanceof TimeoutError) {
				error = response
			}

			if (response instanceof TimeoutError && error.message.includes('v1/products/dsb/price/calculate')) {
				return {
					ok: true,
					status: 200,
					statusText: '',
					responseBody: ''
				}
			}

			return Promise.reject(error)
		})
}

export const isBusy = function() {
	return busyCount > 0
}
